<template>
  <div class="mb-4">
    <div class="d-flex">
      <div class="mr-2" style="margin-top: 2px;" v-if="loading">
        <stat-section-loader></stat-section-loader>
      </div>
      <h2>{{ title }}</h2>
    </div>
    <p v-if="description">{{ description }}</p>
  </div>
</template>

<script>
import StatSectionLoader from './StatSectionLoader.vue';

export default {
  props: ['title', 'description', 'loading'],
  components: {
    StatSectionLoader,
  },
};
</script>
